module.exports = __webpack_public_path__ + "static/media/sitestaffchat.a44ef35a.png";